import { Drawer } from 'antd'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarcode, faCar, faFloppyDisk, faUser, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../../../../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { Select } from '../../../../../../Components/CustomUi/Select'
import { SetStateAction, useState } from 'react'
import Input from '../../../../../../Components/CustomUi/input'
import { BodyDrawer } from './styled'

interface PropsFormulario {
    openForm: boolean
    fecharGaveta: Function
    salvarAtribuição: Function
    carregando_atribuicao: boolean
    carregando_atribuicao_editar: boolean
    update: number
    func_selecionado: string
    setFunc_selecionado: React.Dispatch<React.SetStateAction<string>>
    setFunc_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    veiculo_selecionado: string
    setVeiculo_selecionado: React.Dispatch<React.SetStateAction<string>>
    setVeiculo_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    dataEquipe: any[]
    dataVeiculos: any[]
}

const FormularioAtribuicao: React.FC<PropsFormulario> = ({
    openForm,
    fecharGaveta,
    salvarAtribuição,
    carregando_atribuicao,
    carregando_atribuicao_editar,
    update,
    func_selecionado,
    setFunc_selecionado,
    setFunc_selecionado_id,
    veiculo_selecionado,
    setVeiculo_selecionado,
    setVeiculo_selecionado_id,
    dataEquipe,
    dataVeiculos
}) => {

    const [openFunc, setOpenFunc] = useState<boolean>(false)
    const [openVeiculo, setOpenVeiculo] = useState<boolean>(false)

    return (
        <div>
            <Drawer
                width={500}
                open={openForm}
                onClose={() => fecharGaveta()}
                closable={false}
                bodyStyle={{ padding: 0 }}
                headerStyle={{ padding: '10px 10px' }}
                destroyOnClose
                footer={
                    <div className='footer'>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                            type='primary'
                            onClick={salvarAtribuição}
                            loading={carregando_atribuicao}
                            disabled={carregando_atribuicao}
                        >
                            Salvar
                        </ButtonCustom>
                    </div>
                }
                title={
                    <NavegacaoDrawer>
                        <ButtonCustom
                            danger
                            icon={<FontAwesomeIcon icon={faXmark} />}
                            type='tertiary'
                            onClick={fecharGaveta}
                            style={{ marginLeft: -10 }}
                        >
                            Fechar
                        </ButtonCustom>
                    </NavegacaoDrawer>
                }
            >
                <HeaderDrawer>
                    <div>{update > 0 ? 'Atualizar atribuição' : 'Cadastrar atribuição'}</div>
                </HeaderDrawer>
                <BodyDrawer>
                    <Select
                        label='Funcionário'
                        placeholder='Selecione o funcionário'
                        value={func_selecionado}
                        onChange={setFunc_selecionado}
                        onChangeID={setFunc_selecionado_id}
                        open={openFunc}
                        trigger={setOpenFunc}
                        items={dataEquipe}
                        descricaoItem={'usuario_nome'}
                        idItem={'cod_func'}
                        icon={faUser}
                    />
                    <Select
                        label='Veiculo'
                        placeholder='Selecione o veículo'
                        value={veiculo_selecionado}
                        onChange={setVeiculo_selecionado}
                        onChangeID={setVeiculo_selecionado_id}
                        open={openVeiculo}
                        trigger={setOpenVeiculo}
                        items={dataVeiculos}
                        descricaoItem={'nome'}
                        idItem={'cod'}
                        icon={faCar}
                    />
                </BodyDrawer>
            </Drawer>
        </div>
    )
}

export default FormularioAtribuicao